import { sectionLabels } from "../section-labels";
import { productCardStyleField } from "./_shared";
/**
 * Similar products — OPTIONAL (not locked). The "related products" block on the
 * PDP. Split out of the legacy `product-details` section; unlocked so the seller
 * can remove it (and add it back from the Add-section flow), like
 * `product-policies` / `product-recently-viewed`. Not `criticalForSeo`
 * (peripheral content, not the product itself). Lives under `templates.product`.
 */
export const productRelatedSchema = {
    type: "product-related",
    name: sectionLabels["product-related"],
    description: {
        ar: 'قسم "منتجات مشابهة" أسفل صفحة المنتج.',
        en: "The related-products block shown on the product page.",
    },
    locked: false,
    maxPerTemplate: 1,
    availableOnTemplates: ["product"],
    settings: [
        {
            id: "showRelatedProducts",
            type: "checkbox",
            label: { ar: 'إظهار قسم "منتجات مشابهة"', en: 'Show "Related products"' },
            default: true,
        },
        {
            id: "relatedLayout",
            type: "select",
            label: { ar: "شكل عرض المنتجات المشابهة", en: "Similar products layout" },
            helpText: {
                ar: "شبكة ثابتة، أو شريط أفقي قابل للتمرير.",
                en: "A fixed grid, or a horizontal scrolling carousel.",
            },
            options: [
                { value: "grid", label: { ar: "شبكة", en: "Grid" } },
                { value: "carousel", label: { ar: "شريط متحرك", en: "Carousel" } },
            ],
            default: "grid",
        },
        // Per-section product-card style — same picker as the category sections, so
        // the seller can pick any card design for the "Similar products" row (and
        // it follows the store default on "inherit").
        productCardStyleField(),
    ],
};
//# sourceMappingURL=product-related.js.map